export default "__VITE_ASSET__CkMOm5k7__"